const Summaries = ({ call }) => {
    const { summary, call_score: callScore = {} } = call || {};

    const { strengths = [], opportunities = [] } = callScore || {};

    function formatTagLabel(kebabStr) {
        return kebabStr
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ');
    }

    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {<div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                <h2 className="text-sm font-semibold text-gray-900 mb-3">Call Summary</h2>
                <p className="text-sm text-gray-700 leading-relaxed">{summary || 'No summary available'}</p>
            </div>}

            {/* Agent Feedback */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                <h2 className="text-sm font-semibold text-gray-900 mb-3">Agent Feedback</h2>
                <div className="space-y-3">
                    <div>
                        <div className="flex items-center gap-2 mb-2">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            <h3 className="text-xs font-medium text-green-700 uppercase tracking-wide">Strengths</h3>
                        </div>
                        <ul className="space-y-1 ml-4">
                            {strengths?.map((strength) => (
                                <li key={strength} className="text-sm text-gray-700">{formatTagLabel(strength)}</li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <div className="flex items-center gap-2 mb-2">
                            <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                            <h3 className="text-xs font-medium text-amber-700 uppercase tracking-wide">Opportunities</h3>
                        </div>
                        <ul className="space-y-1 ml-4"> 
                            {opportunities?.map((opportunity) => (
                                <li key={opportunity} className="text-sm text-gray-700">{formatTagLabel(opportunity)}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Summaries;